module.exports = "mat-dialog-content{width:400px;margin-bottom:10px}.btn-unpublish{margin-right:8px}"